module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_umeda-29860ecd2d76b3fef1375fee3e1dc60d.jpg";